import "flyonui/flyonui"



// on .ingresar scroll to .invitacion on load
document.addEventListener("DOMContentLoaded", function () {
    // Verifica si el botón y el destino existen
    const button = document.querySelector(".ingresar");
    const target = document.querySelector(".invitacion");

    if (button && target) {
        // Agrega el evento de clic al botón
        button.addEventListener("click", function () {

            setTimeout(function () {
                target.scrollIntoView({ behavior: "smooth" });
            }, 100); // Puedes ajustar el tiempo si es necesario
        });
    }

    const button2 = document.querySelector(".ircontacto");
    const target2 = document.querySelector(".contacto");
    if (button2 && target2) {
        // Agrega el evento de clic al botón
        button2.addEventListener("click", function () {
       
            setTimeout(function () {
                target2.scrollIntoView({ behavior: "smooth" });
            }, 100); // Puedes ajustar el tiempo si es necesario
        });
    }
});